import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import "plyr/dist/plyr.css";
import { Colors } from "./styles/Colors";

const Wrapper = styled.div`
  --plyr-color-main: ${Colors.yellow};
`;

export default function Video({ url }) {
  const plyrRef = useRef(null);
  const video = useRef(null);

  useEffect(() => {
    if (video.current) {
      const Plyr = require("plyr");

      plyrRef.current = new Plyr(video.current, {
        // FIXME: come back to this once we have thumbnails
        previewThumbnails: { enabled: true },
      });
    }
  }, [video]);

  return (
    <Wrapper>
      <div className="plyr__video-embed" ref={video}>
        <iframe
          src={`${url.replace(
            "watch?v=",
            "embed/"
          )}?iv_load_policy=3&amp;modestbranding=1&amp;playsinline=1&amp;showinfo=0&amp;rel=0&amp;enablejsapi=1`}
          allowFullScreen
          allowtransparency
          allow="autoplay"
        ></iframe>
      </div>
    </Wrapper>
  );
}
